


















// Copyright (c) 2021 by Move Closer

import { defineComponent } from '@vue/composition-api'

import { Container } from '../Container'

import { useViewer, viewerProps } from './Viewer.hook'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const Viewer = defineComponent({
  name: 'Viewer',
  components: { Container },
  props: viewerProps,
  setup: useViewer
})

export default Viewer
